import Highlighter from 'react-highlight-words';

import { QueryType } from 'store/slices/query';

import useTableString from './useTableString';

export interface TableStringProps {
  value: string;
  queryType?: QueryType;
  className?: string;
}

const HIGHLIGHT_PROPS = {
  highlightClassName: 'text-green-400 bg-transparent',
  autoEscape: true,
};

const TableString: React.FunctionComponent<TableStringProps> = function ({
  value,
  queryType = 'rateRequests',
  className = 'text-16-20 text-neutral-900',
}) {
  const searchWords = useTableString(queryType);
  return (
    <Highlighter
      className={className}
      textToHighlight={value}
      searchWords={searchWords}
      {...HIGHLIGHT_PROPS}
    />
  );
};

export default TableString;
